/*
 * UserAskChip — chat 流里的轻量 chip,显示"等待你确认 · 在底部确认 ↓"
 *
 * 用于替代之前 user_ask 在 chat 流的完整卡片渲染.
 * 触发条件:MessagePart.user-ask 带 displayAs='chip' 且用户未提交 (submittedAnswers 为空).
 *
 * 点击 chip 重新打开 UserAskActionSheet (用户关掉 ActionSheet 后想回看 / 重审).
 * 不显示完整问题内容,只一行 hint,完整交互在底部 ActionSheet 独立层.
 */
import React, { useCallback } from 'react'
import { useAppDispatch } from '../../../../app/hooks'
import { openActionSheet } from '../../../../slices/aiClerkUserAskSlice'
import { readSessionId } from '../../utils/track'
import type { MessagePart } from '../../types'
import './UserAskChip.scss'

interface UserAskChipProps {
  part: Extract<MessagePart, { type: 'user-ask' }>
}

const UserAskChip: React.FC<UserAskChipProps> = ({ part }) => {
  const dispatch = useAppDispatch()

  const handleClick = useCallback(() => {
    dispatch(
      openActionSheet({
        pendingId: part.pendingId,
        title: part.title,
        description: part.description,
        questions: part.questions,
        autoFillPreview: part.autoFillPreview,
        sessionId: readSessionId()
      })
    )
  }, [part, dispatch])

  return (
    <button
      type="button"
      className="aiClerk-userAskChip"
      onClick={handleClick}
      aria-label="前往确认"
    >
      <span className="aiClerk-userAskChip__text">
        {part.title || '等待你确认'}
      </span>
      <span className="aiClerk-userAskChip__cta">前往确认 →</span>
    </button>
  )
}

export default UserAskChip
